"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifictaionType = exports.VideoCallStatus = exports.GROUP_INVITER_ROLE = exports.GROUP_RULES_PERMISSION = exports.GROUP_RULES_SUB_CATEGORY = exports.GROUP_RULES_CATEGORY = exports.ConditionType = exports.ChatStatus = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./messageTypes"), exports);
tslib_1.__exportStar(require("./videoTypes"), exports);
var ChatStatus;
(function (ChatStatus) {
    ChatStatus["ACTIVE"] = "ACTIVE";
    ChatStatus["PENDING"] = "PENDING";
    ChatStatus["ENDED"] = "ENDED";
})(ChatStatus = exports.ChatStatus || (exports.ChatStatus = {}));
var ConditionType;
(function (ConditionType) {
    ConditionType["PUSH"] = "PUSH";
    ConditionType["GUILD"] = "GUILD";
})(ConditionType = exports.ConditionType || (exports.ConditionType = {}));
var GROUP_RULES_CATEGORY;
(function (GROUP_RULES_CATEGORY) {
    GROUP_RULES_CATEGORY["PUSH"] = "PUSH";
    GROUP_RULES_CATEGORY["GUILD"] = "GUILD";
    GROUP_RULES_CATEGORY["ERC721"] = "ERC721";
    GROUP_RULES_CATEGORY["ERC20"] = "ERC20";
    GROUP_RULES_CATEGORY["CUSTOM_ENDPOINT"] = "CustomEndpoint";
    GROUP_RULES_CATEGORY["INVITE"] = "INVITE";
})(GROUP_RULES_CATEGORY = exports.GROUP_RULES_CATEGORY || (exports.GROUP_RULES_CATEGORY = {}));
var GROUP_RULES_SUB_CATEGORY;
(function (GROUP_RULES_SUB_CATEGORY) {
    GROUP_RULES_SUB_CATEGORY["DEFAULT"] = "DEFAULT";
    GROUP_RULES_SUB_CATEGORY["HOLDER"] = "holder";
    GROUP_RULES_SUB_CATEGORY["GET"] = "GET";
})(GROUP_RULES_SUB_CATEGORY = exports.GROUP_RULES_SUB_CATEGORY || (exports.GROUP_RULES_SUB_CATEGORY = {}));
var GROUP_RULES_PERMISSION;
(function (GROUP_RULES_PERMISSION) {
    GROUP_RULES_PERMISSION["ENTRY"] = "Entry";
    GROUP_RULES_PERMISSION["CHAT"] = "Chat";
})(GROUP_RULES_PERMISSION = exports.GROUP_RULES_PERMISSION || (exports.GROUP_RULES_PERMISSION = {}));
var GROUP_INVITER_ROLE;
(function (GROUP_INVITER_ROLE) {
    GROUP_INVITER_ROLE["ADMIN"] = "ADMIN";
    GROUP_INVITER_ROLE["OWNER"] = "OWNER";
})(GROUP_INVITER_ROLE = exports.GROUP_INVITER_ROLE || (exports.GROUP_INVITER_ROLE = {}));
var VideoCallStatus;
(function (VideoCallStatus) {
    VideoCallStatus[VideoCallStatus["UNINITIALIZED"] = 0] = "UNINITIALIZED";
    VideoCallStatus[VideoCallStatus["INITIALIZED"] = 1] = "INITIALIZED";
    VideoCallStatus[VideoCallStatus["RECEIVED"] = 2] = "RECEIVED";
    VideoCallStatus[VideoCallStatus["CONNECTED"] = 3] = "CONNECTED";
    VideoCallStatus[VideoCallStatus["DISCONNECTED"] = 4] = "DISCONNECTED";
    VideoCallStatus[VideoCallStatus["ENDED"] = 5] = "ENDED";
    VideoCallStatus[VideoCallStatus["RETRY_INITIALIZED"] = 6] = "RETRY_INITIALIZED";
    VideoCallStatus[VideoCallStatus["RETRY_RECEIVED"] = 7] = "RETRY_RECEIVED";
})(VideoCallStatus = exports.VideoCallStatus || (exports.VideoCallStatus = {}));
var NotifictaionType;
(function (NotifictaionType) {
    NotifictaionType[NotifictaionType["BROADCAT"] = 1] = "BROADCAT";
    NotifictaionType[NotifictaionType["TARGETTED"] = 3] = "TARGETTED";
    NotifictaionType[NotifictaionType["SUBSET"] = 4] = "SUBSET";
})(NotifictaionType = exports.NotifictaionType || (exports.NotifictaionType = {}));
//# sourceMappingURL=index.js.map